import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

import { brandDetector } from '@/brands';

let brandStyles = brandDetector();


const info = {
    state: {
        textosInfoPopup: {
            calendario: {
                titulo: 'Modelo calendario',
                texto: 'Adjunta la plantilla correspondiente, recuerda que solamente puedes aportar una plantilla, si después de aportarla deseas cambiar el modelo o actualizarla, contacta con encargado de la formalización de prácticas en ISFP Claudio Galeno.'
            },
            anexo_7: {
                titulo: 'Modelo Anexo 7',
                texto: 'Adjunta la plantilla correspondiente, recuerda que solamente puedes aportar una plantilla, si después de aportarla deseas cambiar el modelo o actualizarla, contacta con encargado de la formalización de prácticas en ISFP Claudio Galeno.'
            },

            'pendientes': {
                titulo: "Pendientes",
                texto: "Prácticas pendientes de validar por tutor/a académico/a. Estas prácticas pasarán a menú de Validaciones Rechazadas o menú de Prácticas activas en función de si son rechazadas o validadas respectivamente."
            },
            'rechazadas': {
                titulo: "Rechazadas",
                texto: "Prácticas rechazadas por tutor/a académico/a. Estas prácticas no se mostrarán en los menús de Tutorados."
            },
            'en-curso': {
                titulo: "Prácticas activas",
                texto: "Listado de prácticas que tutoriza y que o no han llegado a su fecha de finalización o habiendo llegado no cuentan con la validación de todos los documentos requeridos ratificados."
            },
            'en-evaluacion': {
                titulo: "Prácticas finalizadas",
                texto: "Listado de prácticas que tutoriza y que ya han llegado a su fin y cuentan con todos los documentos requeridos ratificados. Estas prácticas pueden ser cerradas."
            },
            'evaluados': {
                titulo: "Prácticas cerradas",
                texto: "Listado de prácticas que tutoriza y que una vez finalizadas y ratificadas, fueron marcadas como cerradas."
            }

        },
        owntexts: brandStyles.ownpopup_info
    },
    getters: {
        getInfoPopup: state => {
            return (value) => {
                let textos;

                if (state.owntexts) {
                    textos = (!!state.owntexts[value]) ? state.owntexts[value] : state.textosInfoPopup[value];
                } else {
                    textos = state.textosInfoPopup[value];
                }

                return textos;
            }
        },
    },
    actions: {

    },
    mutations: {

    }
}

export default info;



// WEBPACK FOOTER //
// ./src/store/popup-info.js